import { FloraButton } from '@grupoboticario/flora-react';
import { ArrowRightIcon } from '@grupoboticario/flora-react-icons';

import { ResponsiveFloraTypography } from 'components/ResponsiveFloraTypography';
import { DRAWERS, QUERYPARAMS } from 'config/environments/shared';
import { getPaymentStatus } from 'helpers';
import { usePaymentDetail, useDrawer, useTracking } from 'hooks';

import Styles from '../../Drawers.styles';

export const OtherOptions = () => {
  const { setSearchParams, searchParams } = useDrawer(DRAWERS.PAYMENT_DETAIL);
  const { data } = usePaymentDetail(searchParams.get(QUERYPARAMS.PAYMENT_ID) || '');
  const { sendDataToGTM } = useTracking();

  const openRenegotiationDrawer = () => {
    setSearchParams({
      drawer: 'Renegotiation',
      isOpen: 'true',
      paymentId: `${searchParams.get(QUERYPARAMS.PAYMENT_ID)}`,
    });

    sendDataToGTM({
      event: 'analytics-event',
      event_parameters: {
        event_name: 'interaction_renegociar_pagamento',
        cd_interaction_detail: 'click:ver-detalhes-do-pedido',
        transaction_id: data?.paymentTitleId,
        cd_metodo_pagamento: data?.planDetail.toLowerCase(),
        cd_status_pagamento:
          data &&
          getPaymentStatus({
            daysLate: data?.daysLate,
            daysUntilDueDate: data?.daysUntilDueDate,
            paymentStatus: data?.paymentStatus,
            status: data?.status,
          })?.tag.toLowerCase(),
        cd_dias_para_vencimento: data?.daysUntilDueDate,
        cd_dias_apos_vencimento: data?.daysLate,
      },
    });
  };

  const paymentStatus = getPaymentStatus({
    daysLate: data?.daysLate || 0,
    daysUntilDueDate: data?.daysUntilDueDate || 0,
    paymentStatus: data?.paymentStatus || '',
    status: data?.status || '',
  });

  return (
    <>
      {Boolean(paymentStatus?.tag === 'Em aberto') ||
      Boolean(paymentStatus?.tag === 'Em atraso') ? (
        <Styles.DrawerSection align='flex-start' direction='column' gap='$4'>
          <ResponsiveFloraTypography fontSize='title' as='h2' fontWeight='bold'>
            Outras opções
          </ResponsiveFloraTypography>
          <Styles.FullFlex justify='space-between' align='center'>
            <ResponsiveFloraTypography>Renegociação</ResponsiveFloraTypography>
            <FloraButton
              onClick={openRenegotiationDrawer}
              has='iconRight'
              icon={<ArrowRightIcon size={16} />}
              size='small'
              hierarchy='tertiary'
            >
              <ResponsiveFloraTypography fontWeight='bold'>Ver detalhes</ResponsiveFloraTypography>
            </FloraButton>
          </Styles.FullFlex>
        </Styles.DrawerSection>
      ) : null}
    </>
  );
};
